export default "__VITE_ASSET__KVn33yK8__"